import { getBackground } from './utils';

type Props = {
  name?: string;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
};

export const Background = ({ name, className, style, children }: Props) => {
  return (
    <div className={className} style={{ ...style, ...getBackground(name) }}>
      {children}
    </div>
  );
};
